export default __webpack_public_path__ + "1ee70798640925483f8d9917baaf95c1.svg";